<script lang="ts">
	import type { Snippet } from "svelte";
	import { Section } from "#lib/web-ui/primitives/index.js";
	import { faqDefaults, type FaqBaseProps, type FaqItem } from "./faq.types";

	type FaqBaseComponentProps = FaqBaseProps & {
		children: Snippet<
			[{ title: string; subtitle?: string; items: FaqItem[]; contactHref: string }]
		>;
	};

	let {
		theme = faqDefaults.theme,
		id = faqDefaults.id,
		title = faqDefaults.title,
		subtitle = faqDefaults.subtitle,
		items = faqDefaults.items,
		contactHref,
		children
	}: FaqBaseComponentProps = $props();
</script>

<Section {theme} {id}>
	{@render children({ title, subtitle, items, contactHref })}
</Section>
